<template>
	<div>
		<div class="page-filter-box">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.searchValue" class="input-with-select" size="small">
						<el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
							<el-option label="按渠道" :value="1"></el-option>
							<el-option label="按演出Id" :value="2"></el-option>
						</el-select>
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-date-picker v-model="params.startTime" type="date" placeholder="统计起始日期"
						value-format="yyyy-MM-dd" size="small" :clearable="false" :editable="false">
					</el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-date-picker v-model="params.endTime" type="date" placeholder="统计结束日期" value-format="yyyy-MM-dd"
						size="small" :clearable="false" :editable="false">
					</el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
					<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="page-btns-box">
			<el-button v-if="$utils.have('/track/management/data/export')" type="primary" icon="el-icon-download"
			size="small" @click="download" :loading="downLoading">导出</el-button>
		</div>
		<div class="page-list-box">
			<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
				<el-table-column prop="name" label="track渠道名称">
				</el-table-column>
				<el-table-column prop="track" label="track参数值">
				</el-table-column>
				<el-table-column prop="activityId" label="追踪演出id">
				</el-table-column>
				<el-table-column prop="activityName" label="追踪演出名称" min-width="150" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="pv" label="PV">
				</el-table-column>
				<el-table-column prop="uv" label="UV">
				</el-table-column>
				<el-table-column prop="orderNum" label="订单数">
				</el-table-column>
				<el-table-column prop="orderUserNum" label="下单人数">
				</el-table-column>
				<el-table-column prop="saleAmount" label="下单金额">
				</el-table-column>
				<el-table-column prop="commission" label="渠道佣金比">
				</el-table-column>
				<el-table-column prop="commissionAmount" label="渠道佣金">
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" min-width="150">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="130">
					<template slot-scope="scope">
						<el-button v-if="$utils.have('/track/management/data/detail')" type="text" size="small"
						@click="$refs.orderList.show(scope.row)">下单明细</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div v-if="data" class="page-pagination-box">
			<el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
				:current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
				layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
			</el-pagination>
		</div>
		<order-list ref="orderList" @onUpdate="getDataList()"></order-list>
	</div>
</template>
<script>
	import orderList from './orderList.vue';
	import {
		downloadFileTmp
	} from '@/assets/js/commonApi';
	const defaultParams = {
		pageNo: 1,
		startTime: '',
		endTime: '',
		searchType: 1,
		searchValue: ''
	}
	export default {
		components: {
			orderList,
		},
		data() {
			const endTime = this.$utils.formatDate( (new Date().getTime()), 'yyyy-MM-dd' );
			const startTime = this.$utils.formatDate( (new Date().getTime() - 3600 * 1000 * 24 * 90), 'yyyy-MM-dd' );
			return {
				data: null,
				dataList: null,
				listLoading:false,
				dataLoading: false,
				downLoading: false,
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
					searchType: parseInt(this.$route.query.searchType || 1),
					searchValue: this.$route.query.searchValue || "",
					startTime:this.$route.query.startTime || startTime,
					endTime:this.$route.query.endTime || endTime,
				},
			}
		},
		mounted() {
			this.getDataList();
		},
		methods: {
			//获取列表
			getDataList() {
				this.listLoading = true;
				this.$request({
						url: "/track/management/data/list",
						method: "POST",
						data: {
							...this.params,
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = result.result || [];
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,
				};
				this.getDataList();
			},
			//导出
			async download() {
				const Time = this.$utils.formatDate((new Date().getTime()), 'MM.dd');
				let filePath;
				this.downLoading = true;
				const res = await this.$request({
						url: '/track/management/data/export',
						method: 'post',
						data: {
							...this.params,
						},
					})
					.catch(err => {
						this.$message({
							message: err.message,
							type: 'error'
						});
					})
				const {
					state,
					msg,
					result
				} = res.data;
				if (state == 1 && result) {
					filePath = result.url;
				} else {
					this.downLoading = false;
					return this.$message.error(msg || '下载失败');
				}

				await downloadFileTmp(filePath, 'track渠道数据' + Time + '.' + this.$utils.getFileType(filePath));
				this.downLoading = false;
			},

		}
	}
</script>
<style lang="scss" scoped>

</style>